const eventForms = [
  { key: "type", name: "Event Type" },
  { key: "basic", name: "Basic Info" },
  { key: "visibility", name: "Visibility" },
  { key: "advanced", name: "Advanced Settings" }
];

const makeGetFormPath = (delta: number) => (currentKey?: string, eventId?: string) => {
  const prefix = eventId ? `/events/${eventId}/edit` : "/events/new";
  const index = eventForms.findIndex(eventForm => eventForm.key === currentKey);

  return `${prefix}/${eventForms[(index || 0) + delta].key}`;
};

export const getPreviousFormPath = makeGetFormPath(-1);
export const getNextFormPath = makeGetFormPath(1);

export default eventForms;
